module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a342662276e858f9d8bab7bbf17a61c6.png";